import classNames from "classnames";
import React, { useEffect } from "react";
import Modal from "react-modal";

import { toggleModal } from "../../slices/popupSlice";
import { trackPopupViewEvent } from "../../tracking/googleAnalytics";
import { useDispatch, useSelector } from "../../utils/hooks";
import icons from "../../utils/svgProvider";
import { InsuranceModal } from "../insurance/InsuranceModal";
import "./Modal.scss";
import { ScreenInsuranceModal } from "../insurance/ScreenInsuranceModal";

import { MODAL_TYPES } from "./GeneralModal.types";

Modal.setAppElement("#addtocartpopup-modal-container");
Modal.defaultStyles.overlay.backgroundColor = "rgba(0, 0, 0, 0.5)";
Modal.defaultStyles.overlay.zIndex = "1004";

export const GeneralModal = () => {
	const dispatch = useDispatch();
	const isOpen = useSelector((state) => state.popup.modal.isModalOpen);
	const modalId = useSelector((state) => state.popup.modal.id);

	const handleOnModalClose = () => {
		dispatch(toggleModal({ id: "", isOpen: false, config: null }));

		if (MODAL_TYPES.INSURANCE === modalId) {
			trackPopupViewEvent({
				category: "Information",
				name: "Insurance modal closed",
			});
		}
	};

	useEffect(() => {
		if (isOpen) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "";
		}
	}, [isOpen]);

	return (
		<Modal
			closeTimeoutMS={500}
			isOpen={isOpen}
			onRequestClose={handleOnModalClose}
			className={classNames({
				addtocartpopupModal: true,
				large: MODAL_TYPES.INSURANCE === modalId,
			})}
		>
			<button
				className="closeIcon"
				onClick={handleOnModalClose}
				aria-label="Close modal"
			>
				{icons.close}
			</button>
			{MODAL_TYPES.INSURANCE === modalId && <InsuranceModal />}
			{MODAL_TYPES.SCREEN_INSURANCE === modalId && <ScreenInsuranceModal />}
		</Modal>
	);
};
